import React, { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangleIcon, LockIcon, MailIcon } from "lucide-react";
import { AuthCard } from "../../components/auth/AuthCard";
import { SocialButtons } from "../../components/auth/SocialButtons";
import { TextField } from "../../components/ui/TextField";
import { BrutalButton } from "../../components/ui/BrutalButton";
import { shakeKeyframes, shakeTransition } from "../../utils/motion";
export function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("maya@example.com");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [errors, setErrors] = useState<{
    email?: string;
    password?: string;
  }>({});
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(0);
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const next: typeof errors = {};
    if (!/^\S+@\S+\.\S+$/.test(email)) next.email = "Enter a valid email address.";
    if (!password) next.password = "Enter your password.";
    setErrors(next);
    setFormError("");
    if (Object.keys(next).length) return;
    setLoading(true);
    window.setTimeout(() => {
      setLoading(false);
      if (password.toLowerCase() === "wrong") {
        setFormError("That email and password don't match. Try again or reset your password.");
        setShake(s => s + 1);
        return;
      }
      navigate("/app");
    }, 900);
  };
  return <AuthCard title="Welcome back" description="Pick up your streak where you left it." footer={<>
          New to PolyLexa?{" "}
          <Link to="/auth/signup" className="font-semibold text-ink underline underline-offset-4" data-id="element-1701" data-mp="24y69s5rn7f2a">
            Create an account
          </Link>
        </>} data-id="element-1700" data-mp="2xfr0h3a3y9ip">
      <SocialButtons data-id="element-1702" data-mp="1zxqyrkuu2jnh" />
      <motion.form key={shake} animate={shake ? shakeKeyframes : undefined} transition={shakeTransition} onSubmit={submit} noValidate className="space-y-4" data-id="element-1703" data-mp="3wq8ife8moa1">
        <AnimatePresence data-id="element-1704" data-mp="8tp3t19n119t">
          {formError && <motion.p role="alert" initial={{
          opacity: 0,
          y: -6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} className="flex gap-2 rounded-xl border-3 border-line bg-bad-tint px-3.5 py-3 text-sm font-medium text-ink" data-id="element-1705" data-mp="dlqe4hn8whx7">
              <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0" data-id="element-1706" data-mp="3m34mufgf508y" /> {formError}
            </motion.p>}
        </AnimatePresence>
        <TextField label="Email" type="email" icon={MailIcon} value={email} onValueChange={setEmail} error={errors.email} autoComplete="email" data-id="element-1707" data-mp="3r396ufgjcd3x" />
        <TextField label="Password" type="password" icon={LockIcon} value={password} onValueChange={setPassword} error={errors.password} autoComplete="current-password" hint='Demo: any password works — type "wrong" to see an error.' data-id="element-1708" data-mp="16bp4cgd6el3g" />
        <div className="flex items-center justify-between text-sm" data-id="element-1709" data-mp="2qu9cpubw6e9s">
          <label className="flex cursor-pointer items-center gap-2 font-semibold text-ink" data-id="element-1710" data-mp="2m1pziyh49l5i">
            <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} className="h-4 w-4 rounded border-2 border-line accent-[rgb(var(--brand))]" data-id="element-1711" data-mp="2h3eud11rnytm" />
            Remember me
          </label>
          <Link to="/auth/forgot" className="focus-ring rounded-md font-semibold text-ink-2 underline underline-offset-4 hover:text-ink" data-id="element-1712" data-mp="233dnn4ytlx68">
            Forgot password?
          </Link>
        </div>
        <BrutalButton type="submit" full size="lg" loading={loading} data-id="element-1713" data-mp="1c0l2mkbs1dc">
          {loading ? "Signing in…" : "Sign in"}
        </BrutalButton>
      </motion.form>
    </AuthCard>;
}